import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import { Col, Form, Row, DatePicker, Card, Select, message, InputNumber} from 'antd';
import Input from '../../ui/Input';
import { LocalPersistence } from '../../../factories';
import { addAward } from '../../../services/affiliations';
import moment from 'moment';
import PageContainer from '../../CSIComponents/PageContainer';
import Loading from '../../Loading';
import { disableTheDaysToCome } from './../../../helpers/misc/dateValidate';
import ActionButtonsBar from '../../ui/ActionButtonsBar';

const dateFormat = 'MM/DD/YYYY';
const { Option } = Select;
const AddAward = (props: any) => {
  const [form] = Form.useForm();
  const [disabledStatus, setDisabledStatus] = useState(true)
  const [addLoading, setAddLoading] = useState(false)
  const options = ['Crown','Diamond','Star']

  const addSave = () => {
    form.validateFields().then(async (value) => {
      const get_session = new LocalPersistence('session')
      const session: any = await get_session.getSessionPersistence()
      const params = {
        "supplier": session.supplier,
        "propertyId": session.propertyId,
        "property": {
          "affiliations": {
            "awards": [
              {
                ...value,
                dateawarded: (value.dateawarded && moment(value.dateawarded).format(dateFormat)) || ""
              }
            ]
          }
        }
      }
      setAddLoading(true)
      addAward(params).then(res => {
        setAddLoading(false)
        if (res.result.success) {
          setAddLoading(false)
          form.resetFields();
          props.cancelAddAndEdit();
        } else {
          message.error({
            content: res?.error[0]?.message || 'operation failed'
          });
        }
      }, err => {
        message.error({
          content: err.message || err.error[0].message
        });
        setAddLoading(false)
      })
    })
  }
  const validateFieldsError = (isDisabled?: boolean) => {
    if (isDisabled) {
      setDisabledStatus(isDisabled)
      return;
    }
    form.validateFields().then(() => {
      setDisabledStatus(false)

    }).catch(() => {
      const errTotalNum = form.getFieldsError()?.filter(({ errors }: { errors: any }) => errors.length).length;

      if (errTotalNum === 0) {
        setDisabledStatus(false)
      } else {
        setDisabledStatus(true)
      }

    })
  }

  return (addLoading ? <Loading type="large" /> : <div>
    <PageContainer>
      <Card style={{ marginTop: -15 }}>
        <Grid container spacing={0} className="containerSpacing py-0">
          <Grid item xs={12} className="p-0">
            {/* <div style={{ display: 'flex', justifyContent: 'space-between' }}> */}
            <div>
              <div style={{ fontWeight: 600, fontSize: 14, color: '#333' }}>Awards</div>
              {/* <div><Button onClick={addSave}>Edit</Button></div> */}
            </div>
          </Grid>
          <Grid item xs={12} className="pb-0 px-0 my-0">
            <Form
              layout="vertical"
              form={form}
              name="basic"
              onValuesChange={(changedFields, allFields) => {
                validateFieldsError();
              }}
            >
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    label="Award Name"
                    name="name"
                    rules={[{ max: 255, message: 'You have reached the max character length of 255' }]}
                  >
                    <Input maxLength={255} />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label="Date Awarded"
                    name="dateawarded"
                  >
                    <DatePicker 
                      format={dateFormat} 
                      disabledDate={disableTheDaysToCome}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name='officialappointment' label="Official Appointment">
                    <Select allowClear showSearch>
                      <Option value="Yes">Yes</Option>
                      <Option value="No">No</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item
                    label="Provider"
                    name="provider"
                    rules={[{ max: 50, message: 'You have reached the max character length of 50' }]}
                  >
                    <Input maxLength={50} />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label="Rating"
                    name="rating"
                    rules={[
                      { pattern: /^[0-9]+$/, message: 'This field should be an integer number' },
                      { type: "number", min: 0, max:99, message: 'This number should be between 0 and 99' },
                    ]}
                  >
                    <InputNumber className='antInputNumber'/>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name='ratingsymbol' label="Rating Symbol" >
                    <Select allowClear showSearch>
                      { options.map(opt => <Option value={opt}>{ opt }</Option>) }
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

            </Form>
          </Grid>
        </Grid>
      </Card>
      <ActionButtonsBar
        onCancel={() => { props.cancelAddAndEdit(); form.resetFields(); }}
        onSave={addSave}
        disabledSave={disabledStatus}
      />
    </PageContainer>
  </div>);
}
export default AddAward;
